var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-footer"},[_vm._v(" © 2022-2024 Bchannel Inc. All rights reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }